import {DcError, ErrorType} from '@shared-types';

export type ValidatorResult<ErrorText extends string = string> = [isValid: boolean, errorText?: ErrorText];

export type ValidatorTestResult = {
	valid: boolean;
	errors?: string[];
	error?: string;
};

export type ValidatorResults<TestName extends string> = {
	allValid: boolean;
} & {
	[K in TestName]: ValidatorTestResult;
};

export function checkValidatorResults<TestName extends string>(src: string, results: ValidatorResults<TestName>, throwError = false): string[] {
	const tests = Object.keys(results) as TestName[];
	const errors: string[] = [];
	tests.forEach(test => {
		const result = results[test];
		if (!result.valid) {
			if (result.errors?.length > 0) errors.push(...result.errors);
		}
	});
	if (errors.length > 0) {
		const err = DcError({
			name: 'Error validating entity',
			message: `src: ${src}`,
			type: ErrorType.TypeError,
			originalError: errors,
			captureToSentry: true,
		});

		if (throwError) throw err;
		else console.error(err);
	}
	return errors;
}
